<template>
  <div>
    <div class="header">
      <h1 class="page-title">售后订单</h1>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <ul class="menuItems clearfix">
          <li @click="Allorder()">
            <a>全部订单</a>
            <span class="num" v-if="num.all!==undefined">{{num.all}}</span>
          </li>
          <li @click="queryorder(0)">
            <a>申请中</a>
            <span class="num" v-show="num[0]!==undefined">{{num[0]}}</span>
          </li>
          <li @click="queryorder(1)">
            <a>已批准</a>
            <span class="num" v-show="num[1]!==undefined">{{num[1]}}</span>
          </li>
          <li @click="queryorder(2)">
            <a>已驳回</a>
            <span class="num" v-show="num[2]!==undefined">{{num[2]}}</span>
          </li>
        </ul>
        <div class="block">
          <span>下单日期</span>
          <el-date-picker
            v-model="value2"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="date()"
          ></el-date-picker>
          <input type="text" v-model="keywords" placeholder="请输入您要搜索的内容" />
          <button class="searchBtn" @click="selectOrder()">搜索</button>
          <!-- <div class="sy-zongj">
            <i>总计</i>
            <span>
              总订单数:
              <b>{{countOrder}}</b>条
            </span>
            <span>
              总金额:
              <b>{{countMoney}}</b>元
            </span>
          </div>-->
        </div>
      </div>

      <div class="main" style="width:100%; overflow-x: auto; overflow-y: auto;">
        <table
          width="100%"
          cellpadding="0"
          cellspacing="0"
          style="table-layout:fixed;"
          class="orderTab"
          v-loading="loading"
        >
          <thead>
            <td width="30">序号</td>
            <th width="140">订单号</th>
            <th width="120">产品名称</th>
            <th width="70">退款类型</th>
            <th width="140">退款理由</th>
            <th width="140">退款图片</th>
            <th width="80">申请退款金额(元)</th>
            <th width="80">订单状态</th>
            <th width="130">申请售后时间</th>
            <th width="100">联系手机</th>
            <th width="160">快递单号</th>
            <th width="200">回复</th>
            <th width="75">操作</th>
          </thead>
          <template v-if="JSON.stringify(orderListData) !='[]'">
            <tbody
              :class="[item.length==1?'':'orange']"
              v-for="(item,index) in orderListData"
              :key="index"
            >
              <!-- 未合包布局 -->

              <template v-if="item.length==1">
                <tr>
                  <td>{{indexMethod(index)}}</td>
                  <td>{{item[0].order_id}}</td>
                  <td>{{item[0].product_name}}</td>
                  <td>{{item[0].backtype}}</td>
                  <td>{{item[0].querytype}}</td>
                  <td>
                    <img
                      :src="item[0].backimg"
                      class="backimg"
                      @click="imgcoo(item[0].id)"
                      :class="active1==item[0].id&&isshow ? 'active' : '' "
                    />
                  </td>
                  <td>{{item[0].money}}</td>

                  <td>
                    <el-tag v-if="item[0].status==0">申请中</el-tag>
                    <el-tag type="success" v-else-if="item[0].status==1">已批准</el-tag>
                    <el-tag type="danger" v-else>已驳回</el-tag>
                  </td>
                  <td>{{item[0].createtime|dateFormat}}</td>
                  <td>{{item[0].phone}}</td>
                  <td>{{item[0].expressno}}</td>
                  <td>{{item[0].bhquery}}</td>
                  <td>
                    <button class="cz xq" @click="orderDetail(item[0].id)">订单详情</button>
                  </td>
                </tr>
              </template>
              <!-- 合包布局 -->
              <template v-else>
                <template v-for="(item1,index1) in item">
                  <tr v-if="index1==0" :key="item1.id">
                    <td :rowspan="item.length">{{indexMethod(index)}}</td>
                    <td>{{item1.order_id}}</td>
                    <td :rowspan="item.length">{{item1.product_name}}</td>
                    <td :rowspan="item.length">{{item1.backtype}}</td>
                    <td :rowspan="item.length">{{item1.querytype}}</td>
                    <td :rowspan="item.length">
                      <img
                        :src="item[0].backimg"
                        class="backimg"
                        @click="imgcoo(item[0].id)"
                        :class="active1==item[0].id&&isshow ? 'active' : '' "
                      />
                    </td>
                    <td :rowspan="item.length">{{item1.money}}</td>
                    <td :rowspan="item.length">
                      <el-tag v-if="item1.status==0">申请中</el-tag>
                      <el-tag type="success" v-else-if="item1.status==1">已批准</el-tag>
                      <el-tag type="danger" v-else>已驳回</el-tag>
                    </td>
                    <td :rowspan="item.length">{{item1.createtime|dateFormat}}</td>
                    <td :rowspan="item.length">{{item1.phone}}</td>
                    <td :rowspan="item.length">{{item1.expressno}}</td>
                    <td :rowspan="item.length">{{item1.bhquery}}</td>
                    <td :rowspan="item.length">
                      <button class="cz xq" @click="orderDetail(item[0].id)">订单详情</button>
                    </td>
                  </tr>
                  <tr v-else>
                    <td>{{item1.order_id}}</td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
          <div class="zw" v-else>暂无数据</div>
        </table>

        <el-pagination
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :total="pageCount"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </el-card>
    <div class="message clearfix">
      <p>列表默认显示当天，你可通过时间搜索</p>
      <span>
        合计:
        <b>{{numCount +'单 - ' + Cmoney +'元' }}</b>
      </span>
    </div>
    <el-drawer title="订单详情" :visible.sync="drawer" direction="rtl" size="60%" destroy-on-close>
      <div v-loading="loading">
        <div class="parmengInfo">
          <ul class="clearfix">
            <li class="sy_one">
              <span class="borderTop"></span>
              <div class="itemBox">
                <div class="infoTitle">收货人信息</div>
                <div class="sy-content">
                  <p>
                    收货人：
                    <span>{{spinfo.name}}</span>
                  </p>
                  <p>
                    现地址：
                    <span>{{spinfo.address}}</span>
                  </p>
                  <p>
                    手机号：
                    <span>{{spinfo.phone}}</span>
                  </p>
                </div>
              </div>
            </li>
            <li class="sy_two">
              <span class="borderTop"></span>
              <div class="itemBox">
                <div class="infoTitle">配送信息</div>
                <div class="sy-content">
                  <p>
                    配送方式：
                    <span>{{psinfo.express_id}}</span>
                  </p>
                  <p>
                    快递运费：
                    <span>{{psinfo.shipping_fee}}</span>
                  </p>
                  <p>
                    买家留言：
                    <span>{{psinfo.mark}}</span>
                  </p>
                </div>
              </div>
            </li>
            <li class="sy_three">
              <span class="borderTop"></span>
              <div class="itemBox">
                <div class="infoTitle">付款信息</div>
                <div class="sy-content">
                  <p>
                    付款方式：
                    <span>{{priceinfo.pay_way}}</span>
                    &nbsp; &nbsp; &nbsp; &nbsp; 优惠金额：
                    <span>{{'￥'+priceinfo.discount_fee}}</span>
                  </p>
                  <p>
                    运费金额：
                    <span>{{'￥'+priceinfo.shipping_fee}}</span>
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 产品总额：
                    <span>{{'￥'+priceinfo.pay_price}}</span>
                  </p>
                  <p>
                    支付金额：
                    <span>{{'￥'+priceinfo.total_price}}</span>
                  </p>
                </div>
              </div>
            </li>
            <li class="sy_focu">
              <span class="borderTop"></span>
              <div class="itemBox">
                <div class="infoTitle">发票信息</div>
                <p>暂无</p>
              </div>
            </li>
          </ul>
        </div>
        <el-table :data="orderDetailInfo.data" border style="width: 100%">
          <el-table-column prop="product_name" label="产品名称"></el-table-column>
          <el-table-column prop="title" label="规格" width="300"></el-table-column>
          <el-table-column prop="filename" width="350" label="文件名">
            <template slot-scope="scope">{{scope.row.filename.slice(77)}}</template>
          </el-table-column>
          <el-table-column prop="goods_price" label="产品金额"></el-table-column>
          <el-table-column prop="number" label="数量"></el-table-column>
          <el-table-column prop="discount_fee" label="优惠金额">
            <template slot-scope="scope">{{!scope.row.discount_fee ? '0' : scope.row.discount_fee}}</template>
          </el-table-column>
        </el-table>
        <!-- 订单日志 -->
        <el-table :data="orderrZhi" border style="width: 100%;margin-top:20px">
          <el-table-column prop="order_no" label="订单号" width="300"></el-table-column>
          <el-table-column prop="createtime" label="操作时间" width="300">
            <template slot-scope="scope">{{scope.row.createtime | dateFormat}}</template>
          </el-table-column>
          <el-table-column prop="remark" width="350" label="备注"></el-table-column>
          <el-table-column prop="status_str" label="状态"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      value2: null,
      //   订单状态列表
      orderStatusList: [],
      orderListData: [],
      token: window.localStorage.getItem('token'),
      page: '1',
      keywords: '',
      loading: true,
      pageCount: 1,
      status: '',
      mindate: '',
      maxdate: '',
      countOrder: 0,
      countMoney: 0,
      orderDetailInfo: [],
      goods_price: '',
      shipping_fee: '',
      total_price: '',
      psinfo: [],
      priceinfo: [],
      spinfo: [],
      drawer: false,
      active1: '',
      isshow: false,
      orderrZhi: [],
      num: {},
      numCount: 0, //订单数
      Cmoney: 0 //总计
    }
  },
  created() {
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.queryOrderList()
    this.getYue()
  },
  methods: {
    // 订单详情
    async orderDetail(order_no) {
      this.orderDetailInfo = []
      this.goods_price = ''
      this.shipping_fee = ''
      this.total_price = ''
      this.spinfo = []
      this.psinfo = []
      this.priceinfo = []
      this.drawer = true
      this.loading = true
      let param = new URLSearchParams()
      param.append('bid', order_no)
      this.orderrZhi = []
      const { data: resl } = await this.$http({
        method: 'post',
        url: 'api/order/deatil',
        data: param
      })
      const { data: result } = await this.$http({
        method: 'post',
        url: 'api/order/deatilxq',
        data: param
      })
      const { data: ress } = await this.$http({
        method: 'post',
        url: 'api/order/orderlog',
        data: param
      })
      this.loading = false
      if (ress.code == 1) {
        this.orderrZhi = ress.data
      }
      if (resl.code == 1) {
        this.orderDetailInfo = resl.data
        this.goods_price = resl.data.price.goods_price
        this.shipping_fee = resl.data.price.shipping_fee
        this.total_price = resl.data.price.total_price
      }
      this.spinfo = result.data.spinfo
      this.psinfo = result.data.psinfo
      this.priceinfo = result.data.priceinfo
    },
    Allorder() {
      this.value2 = ''
      this.status = ''
      this.keywords = ''
      this.mindate = ''
      this.maxdate = ''
      this.page = 1
      this.queryOrderList()
    },
    selectOrder() {
      this.queryOrderList()
    },

    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    queryorder(status) {
      if (status == 0) {
        this.mindate = ''
        this.maxdate = ''
      } else if (this.value2 == null || !this.value2) {
        this.mindate =
          new Date().toLocaleDateString().replace(/\//g, '-') + ' 00:00:00'
        this.maxdate =
          new Date().toLocaleDateString().replace(/\//g, '-') + ' 23:59:59'
      }
      this.status = status
      this.queryOrderList()
    },
    date() {
      if (this.value2 != null) {
        this.mindate = this.value2[0] + ' 00:00:00'
        this.maxdate = this.value2[1] + ' 23:59:59'
      } else {
        this.mindate = ''
        this.maxdate = ''
      }
    },
    indexMethod(index) {
      if (this.page == 1) {
        return index + 1
      }
      if (index + 1 == 10) {
        return this.page + '' + 0
      }
      return this.page - 1 + '' + (index + 1)
    },
    //   订单列表
    handleCurrentChange(val) {
      this.page = val

      this.queryOrderList()
    },
    async queryOrderList() {
      this.loading = true
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('status', this.status)
      param.append('keywords', this.keywords)
      param.append('page', this.page)
      param.append('mindate', this.mindate)
      param.append('maxdate', this.maxdate)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/backorder/index',
        data: param
      })
      this.loading = false

      if (res.code == 1 && res.data !== null) {
        this.orderListData = res.data.data
        this.pageCount = res.data.page_count * 10
        this.numCount = res.data.count
        this.Cmoney = res.data.money

        if (res.data.ftotal) {
          this.num = res.data.ftotal
        }
        if (res.data.num_count) {
          this.countOrder = res.data.num_count
          this.countMoney = res.data.price_count.toFixed(2)
        } else {
          this.countOrder = 0
          this.countMoney = 0
        }
      }
    },
    imgcoo(a) {
      this.active1 = a
      this.isshow = !this.isshow
    }
  },
  mounted() {
    $('.menuItems').on('click', 'li', function() {
      $(this)
        .children('a')
        .css({ color: '#a77c5a', 'border-left': '3px solid #a77c5a' })
      $(this)
        .siblings('li')
        .children('a')
        .css({ color: '#666', 'border-left': '3px solid #ccc' })
    })
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.el-card {
  ul {
    li {
      float: left;
      padding: 0px 15px;
      margin-right: 30px;
      height: 30px;
      cursor: pointer;
      position: relative;
      a {
        padding-left: 5px;
        display: block;
        height: 15px;
        line-height: 15px;
        border-left: 3px solid #ccc;
        transition: all 0.3s;
      }
      a:hover {
        border-left: 3px solid #a77c5a;
      }
      .num {
        display: block;
        background: red;
        border-radius: 50%;
        position: absolute;
        top: -4px;
        right: -3px;
        transform: scale(0.9);
        text-align: center;
        line-height: 15px;
        color: #fff;
        padding: 2px;
        min-width: 15px;
        min-height: 15px;
      }
    }
  }
  .block {
    position: relative;
    margin-top: 30px;
    span {
      margin-right: 10px;
      color: #666;
    }
    input {
      box-shadow: 0px 0px 1px 1px #eee;
      padding-left: 10px;
      margin-left: 30px;
      width: 220px;
      height: 30px;
    }
    .searchBtn {
      padding: 8px 20px;
      margin-top: 5px;
      margin-left: 15px;
      color: #fff;
      background: #a77c5a;
      border-radius: 3px;
    }
    .sy-zongj {
      position: absolute;
      top: 13px;
      left: 800px;
      font-size: 16px;
      b {
        color: #e83030;
      }
    }
  }
  .main {
    font-size: 12px;
    .backimg {
      width: 100px;
      transform: scale(1); /*图片原始大小1倍*/
      transition: all ease 0.5s;
      position: relative; /*图片放大所用时间*/
    }
    .active {
      transform: scale(7); /*图片需要放大3倍*/
      position: fixed; /*是相对于前面的容器定位的，此处要放大的图片，不能使用position：relative；以及float，否则会导致z-index无效*/
      z-index: 100;
      top: 50%;
      left: 45%;
    }
    .orange {
      background-color: #f0fff0;
      border-bottom: 2px solid #a77c5a;
    }
    .cz {
      font-size: 12px !important;
      margin-left: 5px;
    }
  }
  .el-pagination {
    margin: 40px 0 0 700px;
  }
}
.parmengInfo {
  margin-bottom: 20px;
  ul {
    display: flex;
    li {
      position: relative;
      float: left;
      margin-right: 20px;
      border: 1px solid #eee;
      box-shadow: 0 0 1px 1px #f0efef;
      border-top: 0;
      .borderTop {
        position: absolute;
        top: 0;
        display: block;
        width: 100%;
        height: 10px;
        background: url('../../../assets/user/border-top.png') no-repeat;
      }
      .itemBox {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 30px 10px 10px;
        .infoTitle {
          font-size: 14px;
          color: #666;
        }
      }
      .sy-content {
        margin-top: 5px;
        font-size: 12px;
        color: #777;
      }
    }
    .sy_one {
      flex: 20%;
    }
    .sy_two {
      flex: 20%;
    }
    .sy_three {
      flex: 30%;
    }
    .sy_focu {
      flex: 30%;
    }
  }
}
.priceInfo {
  margin-top: 30px;
  padding-right: 30px;
  float: right;
  p {
    margin-bottom: 5px;
    font-size: 14px;
    color: #666;
    i {
      font-size: 20px;
      color: #e83030;
    }
  }
}
.xq {
  padding: 5px;
  color: #fff;
  border-radius: 5px;
  font-size: 12px;
  margin-bottom: 5px;
  background-color: #4da5ff;
}
.orderTab {
  position: relative;
  height: 80px;
  th {
    padding: 10px 5px;
    background-color: #fafafa;
  }

  td {
    padding: 10px;
    border: 1px solid #eee;
    font-size: 12px;
    color: #666;
  }
  .zw {
    font-size: 18px;
    color: #666;
    text-align: center;
    position: absolute;
    top: 50px;
    right: 750px;
  }
}
.message {
  position: absolute;
  top: 250px;
  right: 100px;
  font-size: 16px;
  p {
    font-weight: bold;
    color: #a77c5a;
  }
  span {
    float: right;
    margin-top: 8px;
    b {
      color: #e83030;
    }
  }
}
</style>